// testimonial slider
$('#testimo').owlCarousel({
  items: 1,
  loop: true,
  autoplay: true,
  dots:false,
  autoplaySpeed: 3500,
  nav: true,
  animateOut: 'slideOutRight',
  animateIn: 'slideInRight'
});

// product image hover
document.querySelectorAll(".product-list li").forEach(item => {
  item.addEventListener("mouseenter", () => {
    const imgPath = item.getAttribute("data-img");
    document.getElementById("product-preview").src = imgPath;
    document.querySelectorAll(".product-list li").forEach(li => li.classList.remove("active"));
    item.classList.add("active");
  });
});

// text animation
const heading = document.querySelector(".animated-heading");
if(heading == null){
  
}
else{
  const text = heading.innerHTML.replace(/<br\s*\/?>/gi, '\n'); // handle <br> as \n
  heading.innerHTML = '';
  
  let delay = 0;
  text.split('').forEach(char => {
    if (char === '\n') {
      const br = document.createElement("span");
      br.className = "line-break";
      heading.appendChild(br);
    } else {
      const span = document.createElement("span");
      span.className = "letter";
      span.textContent = char === " " ? "\u00A0" : char; // non-breaking space
      span.style.animationDelay = `${delay}s`;
      delay += 0.1;
      heading.appendChild(span);
    }
  })

}